const DEFAULT_CONDITIONAL_FAIL_VALUE = 'No';

export const getConditionalFailValues = (question) => {
  const failValues = question?.conditionalFailValues ?? question?.conditionalFailValue;
  if (failValues === undefined) return [DEFAULT_CONDITIONAL_FAIL_VALUE];
  return Array.isArray(failValues) ? failValues : [failValues];
};

export const getConditionalPassValues = (question) => {
  if (question?.conditionalPassValues?.length) return question.conditionalPassValues;
  const options = question?.options || [];
  const failSet = new Set(getConditionalFailValues(question));
  return options.filter((option) => !failSet.has(option));
};

export const formatExpectedAnswers = (expectedAnswers) => {
  if (!expectedAnswers?.length) return 'Cumplir con este requisito';
  if (expectedAnswers.length === 1) return expectedAnswers[0];
  if (expectedAnswers.length === 2) {
    return `${expectedAnswers[0]} o ${expectedAnswers[1]}`;
  }
  return `${expectedAnswers.slice(0, -1).join(', ')} o ${
    expectedAnswers[expectedAnswers.length - 1]
  }`;
};

export const getFormConditionalQuestions = (formQuestion, formQuestions = {}) => {
  const steps = formQuestions[formQuestion] || [];
  const seenIds = new Set();
  const conditionalQuestions = [];

  steps.forEach((step) => {
    (step || []).forEach((question) => {
      if (
        question?.id?.includes('conditional') &&
        question.type === 'select' &&
        !seenIds.has(question.id)
      ) {
        seenIds.add(question.id);
        conditionalQuestions.push(question);
      }
    });
  });

  return conditionalQuestions;
};

export const isQuestionVisible = (question, inputs = {}) => {
  if (!question?.showWhen) return true;
  const { id, value } = question.showWhen;
  return inputs[id] === value;
};

export const isConditionalRequirementActive = (question, inputs = {}) => {
  if (!isQuestionVisible(question, inputs)) return false;
  if (!question?.conditionalRequiredWhen) return true;
  const { id, value } = question.conditionalRequiredWhen;
  return inputs[id] === value;
};

export const isConditionalRequirementFailed = (question, value, inputs = {}) => {
  if (!question?.id?.includes('conditional')) return false;
  if (!isConditionalRequirementActive(question, inputs)) return false;
  return getConditionalFailValues(question).includes(value);
};

export const getFailedConditionalRequirements = (formQuestion, inputs = {}, formQuestions = {}) =>
  getFormConditionalQuestions(formQuestion, formQuestions)
    .filter((question) => isConditionalRequirementFailed(question, inputs[question.id], inputs))
    .map((question) => ({
      question: question.text,
      userAnswer: inputs[question.id] || 'Sin respuesta',
      expectedAnswer: formatExpectedAnswers(getConditionalPassValues(question)),
    }));

export const getMissingConditionsContent = (formQuestion, inputs, formQuestions) => {
  const items = getFailedConditionalRequirements(formQuestion, inputs, formQuestions);
  if (items.length === 0) return [];

  return [
    {
      type: 'missingConditions',
      intro: 'Según tus respuestas, aún no cumples con los siguientes requisitos:',
      outro: 'Te invitamos a completar estos puntos para que puedas continuar con el proceso.',
      items,
    },
  ];
};
